import { render, staticRenderFns } from "./InvestorTransactionItem.vue?vue&type=template&id=7a2e0f5b&scoped=true&"
import script from "./InvestorTransactionItem.vue?vue&type=script&lang=js&"
export * from "./InvestorTransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorTransactionItem.vue?vue&type=style&index=0&id=7a2e0f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e0f5b",
  null
  
)

export default component.exports